import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import { Heading } from '@nerdwallet/currency';
import { getOfferId } from '@nerdwallet/marketplace/selectors/common';
import { KetoCompareCardCheckBox, CHECKBOX_STYLE } from '@nerdwallet/compare-credit-cards-bar';
import { getLegacyId } from '@nerdwallet/marketplace/selectors/credit-cards';
import { buildTrkSectionCategory, sanitizeNode } from '../lib/utils';
import { TRK_PRODUCT_LOCATION } from '../lib/constants';
import styles from './keto-product-card.module.less';

var KetoProductCardHeader = function KetoProductCardHeader(_ref) {
  var className = _ref.className,
      heading = _ref.heading,
      marketplaceEntity = _ref.marketplaceEntity,
      _hasCcCompareButton = _ref._hasCcCompareButton,
      _handleCcCompareClick = _ref._handleCcCompareClick,
      checkboxLabel = _ref.checkboxLabel,
      enableAnalytics = _ref.enableAnalytics,
      reviewLinkHref = _ref.reviewLinkHref,
      shouldLogImpression = _ref.shouldLogImpression,
      taxonomy = _ref.taxonomy,
      trkPageType = _ref.trkPageType,
      trkProductPosition = _ref.trkProductPosition,
      trkSectionCategory = _ref.trkSectionCategory,
      ctaHref = _ref.ctaHref,
      displayPage = _ref.displayPage,
      omitCta = _ref.omitCta,
      productCardPreheader = _ref.productCardPreheader,
      isPreheaderBadge = _ref.isPreheaderBadge,
      hasPreheader = _ref.hasPreheader,
      isSelectedToCompare = _ref.isSelectedToCompare;
  var impressionContext = useContext(ImpressionContext);
  var productCardHeading = /*#__PURE__*/React.createElement(Heading, {
    color: "neutral-darkest",
    className: classNames([styles.ketoHeadingText, !hasPreheader && styles.ketoHeadingTextPadding]),
    level: "3",
    size: "3"
  }, sanitizeNode(heading));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, hasPreheader && /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.ketoPreheaderContainer, !isPreheaderBadge && styles.preHeaderTopMargin, isPreheaderBadge && styles.preheaderContainerBadge])
  }, productCardPreheader), /*#__PURE__*/React.createElement("div", {
    className: styles.heading
  }, omitCta ? productCardHeading : /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    className: styles.headingLink,
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-name-").concat(trkProductPosition),
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: APPLY_NOW_LINK_TYPES.productName,
    marketplaceEntity: marketplaceEntity,
    productLocation: TRK_PRODUCT_LOCATION,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    shouldLogImpression: shouldLogImpression,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'productName'),
    trkTaxonomy: taxonomy,
    type: LINK_TYPES.LINK // BNK specific props.
    ,
    displayPage: displayPage,
    disableBankCtaAnnotation: true
  }, productCardHeading)), _hasCcCompareButton && /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.compareBtnDesktop, isPreheaderBadge && styles.compareTopMargin])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.compareCheckbox
  }, /*#__PURE__*/React.createElement(KetoCompareCardCheckBox, {
    card: {
      id: getLegacyId(marketplaceEntity),
      offerId: getOfferId(marketplaceEntity)
    },
    analytics: {
      enabled: enableAnalytics
    },
    showCheckboxLabel: true,
    checkboxLabel: checkboxLabel,
    handleCompare: _handleCcCompareClick,
    isSelectedToCompare: isSelectedToCompare
  }))), _hasCcCompareButton && /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.compareBtnMobile, isPreheaderBadge && styles.compareTopMargin])
  }, /*#__PURE__*/React.createElement(KetoCompareCardCheckBox, {
    card: {
      id: getLegacyId(marketplaceEntity),
      offerId: getOfferId(marketplaceEntity)
    },
    analytics: {
      enabled: enableAnalytics
    },
    showCheckboxLabel: false,
    handleCompare: _handleCcCompareClick,
    elementStyle: CHECKBOX_STYLE.BUTTON,
    isSelectedToCompare: isSelectedToCompare
  })));
};

KetoProductCardHeader.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.node.isRequired,
  marketplaceEntity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  _hasCcCompareButton: PropTypes.bool,
  _handleCcCompareClick: PropTypes.func,
  checkboxLabel: PropTypes.string,
  omitCta: PropTypes.bool,
  reviewLinkHref: PropTypes.string,
  shouldLogImpression: PropTypes.bool,
  taxonomy: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  trkPageType: PropTypes.string,
  trkProductPosition: PropTypes.number,
  trkSectionCategory: PropTypes.string,
  isSelectedToCompare: PropTypes.bool,
  // BNK specific props.
  displayPage: PropTypes.string,
  ctaHref: PropTypes.string,
  productCardPreheader: PropTypes.node,
  isPreheaderBadge: PropTypes.bool,
  hasPreheader: PropTypes.bool,
  // bedrock instrumentation props
  // A flag to indicate if analytics is being sent.
  enableAnalytics: PropTypes.bool
};
export default KetoProductCardHeader;